<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- boton crear -->
    <v-row class="pt-0 mt-3" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse pt-0">
        <TableButtonCompVue @click="addItem()" iconBut="fas fa-plus" textButton="Crear personal" normalButton />
      </v-col>
    </v-row>

    <!-- consultar -->
    <ComundataTablecompVue :headers="RegistropersonalHeaders" :items="Datos" whitSearch
      noResultsText="Sin personal registrado" placeholderTextsearch="Buscar personal">
      <template v-slot:profesorValor="{ item }">
        <v-chip v-if="item.es_profesor === 1" class="color_activo" small>SÍ</v-chip>
        <v-chip v-if="item.es_profesor === 0" class="color_inactivo" small>NO</v-chip>
      </template>

      <template v-slot:estadoValor="{ item }">
        <div class="switch-container">
          <v-switch color="success" v-model="item.estado_personal" inset
            @change="updateStatePersonal(item.id, item.estado_personal)"></v-switch>
          <span class="switch-text" :style="item.estado_personal == 1 ? 'width: 80%' : 'width: 100%'">{{
            item.estado_personal == 1 ? 'ACTIVO' : 'INACTIVO'
          }}</span>
        </div>
      </template>

      <template v-slot:action_editar="{ item }">
        <TableButtonCompVue v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
          tooltipText="Editar personal" />
      </template>

      <!-- <template v-slot:action_borrar="{ item }">
        <TableButtonCompVue v-if="componenteEvento.borrar_submodulo" @click="showmodalDelete(item.id)"
          tooltipText="Eliminar personal" deleteButton />
      </template> -->
    </ComundataTablecompVue>


    <v-form ref="formDatosValidar" lazy-validation>
      <ComunDialogCompVue v-model="dialogValidar" title="Ingresar número de documento"
        @close-modal="(dialogValidar = false), (InputUpdate = true)" max-width="450px">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" sm="12" class="pb-0">
              <!-- <textfieldComp type v-model="documento_validar" textLabel="N.° de documento de identidad" v-mask="'XXXXXXXXXXXXXXX'"
                :rules="validationRules.validateDocument" /> -->

                <v-text-field class="mb-3" @keydown.enter="validarDoc" autofocus v-model="documento_validar" label="N.° de documento de identidad" variant="underlined" v-mask="'XXXXXXXXXXXXXXX'" :rules="validationRules.validateDocument"></v-text-field>
                <AutocompleteComp
                textLabel="Tipo de personal"
                v-model="id_tipo_personal"
                :items="tipo_personal"
                item-value="id"
                item-text="desc_tipo_personal"
                :rules="validationRules.validateCampo"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions>
          <v-row dense>
            <v-col cols="12" class="d-flex justify-end gap-10px">
              <TableButtonCompVue normalButton @click="validarDoc" iconBut="fas fa-check" text-button="Validar" />
              <TableButtonCompVue normalButton @click="dialogValidar = false" classColor="red" text-button="Cancelar" />

            </v-col>
          </v-row>
        </template>
      </ComunDialogCompVue>
    </v-form>
    <!-- fin de modal agregar perfil -->

    <!-- <confirm @cancelar="clear_confirm" titleWindow="Eliminar personal" @aceptar="updateStatePersonal"
      :title="confirm.title" :active="confirm.active" /> -->

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" :parametros2="respuestaValidDocUsers" :usersParams="UsersData" @reloadComp="reloadComp"
      @close="estadoComponente = false">
    </component>
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
// eslint-disable-next-line
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
// eslint-disable-next-line
import moment from "moment";
import ComundataTablecompVue from "../../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonCompVue from "../../../components/ComponentsEst/TableButtonComp.vue";
import ComunDialogCompVue from "../../../components/ComponentsEst/ComunDialogComp.vue";
import textfieldComp from "../../../components/ComponentsEst/textfieldComp.vue";
import { RegistropersonalHeaders } from "@/helpers/headersTable.js";
import { validationRules } from "@/helpers/validatorHelpers.js";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import formRegistroPersonal from "./registroPersonalForm.vue";

export default {
  components: {
    formRegistroPersonal,
    ComundataTablecompVue,
    TableButtonCompVue,
    ComunDialogCompVue,
    textfieldComp,
    AutocompleteComp
  },

  data() {
    return {
      //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
      paramComponente: { id_submodulo: 19, id_modulo: 6 }, //sud_modulo y modulo

      datoLogin: sessionStorage, // variables de sesion del usuario
      ////////////////////////////////////////////////////////
      RegistropersonalHeaders,
      compName: "",
      estadoComponente: false,
      parametroComp: {},

      /* confirms */
      confirm: {
        id: 0,
        title: "",
        active: false,
        action: 0, // 1:personal, 2:formacion, 3:idiomas, 4:capacitacion, 5:experiencia, 6:seguro
      },
      estadoPersonales: [],
      metodo: "agregar",
      search: "",

      // modal verificar si existe numero documento persona
      dialogValidar: false,

      documento_validar: "",
      InputUpdate: false,
      respuestaValidDoc: [],
      respuestaValidDocUsers:[],
      //////////////////////////////////////

      Datos: [],
      persona: [],
      personal: [],
      id_tipo_personal: 0,
      tipo_personal:[],

      rutaServer: `${API_URL}/`,
      //rutaServer: 'http://localhost:5000/',

      avatar: {
        url: null,
        state: false,
      },

      //validaciones de formulario

      //Variables de Usuarios
      UsersData: {},
    };
  },

  computed: {
    validationRules() {
      return validationRules;
    },
    ...mapGetters("login", ["componenteEvento"]),
  },

  async created() {
    await this.actualizarParamentro();

    this.$on('usuarioCreado', () => {
      this.getAll();
    });
  },

  mounted() {
    this.getAll();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    async actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
      this.confirm.action = 0;
    },
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    // this.setEnviarMens({tipo:"E", mensaje: `Error: ${error}`, tiempo:null})
    // Nuevo 2020/03//24 wuilmer garcia
    ////////////////////////////////////////////////////////


    cambiarEstado() {

      console.log('estados', this.estadoPersonales);

    },

    async getAll() {
      try {
        let response = await axios.get(
          "/administrativo/personal/personalView/" + this.datoLogin.id_colegio
        );
        this.Datos = response.data;

        this.getAllTipoPersonal()
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    addItem() {
      this.$refs.formDatosValidar.resetValidation();
      this.dialogValidar = true;
      this.documento_validar = "";
    },

    editItem(item) {
      this.parametroComp = { evento: "editar", item };
      this.compName = "formRegistroPersonal";
      this.estadoComponente = true;
    },

    reloadComp() {

      this.getAll();
      // this.loadMain()
      // this.estadoComponente=false
    },

    async getAllTipoPersonal() {
      try {
        let response = await axios.get("/mantenimiento/tipospersonales");
        this.tipo_personal = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async validarDoc() {
      if (this.$refs.formDatosValidar.validate()) {
        this.dialogValidar = false;

        try {
          
          ////////////// Valida si existe la persona ////////////////////////
          let responseUsers = await axios.get(
            "/sistema/usuario/validarDocumento/Documento/" +
            this.documento_validar +
            "/colegio/" +
            this.datoLogin.id_colegio
          );
          
          this.respuestaValidDocUsers = responseUsers.data;
  
          let filterValidPerfil = this.respuestaValidDocUsers.filter( e => e.id_mant_tipo_personal == this.id_tipo_personal)
          
          if (filterValidPerfil.length > 0) {
            this.setEnviarMens({
              tipo: "W",
              mensaje: "Existe información asociada a este número de documento y tipo de personal.",
              tiempo: null,
            });
          } 
          else {
            // this.setEnviarMens({
            //   tipo: "W",
            //   mensaje:
            //     "No existe este tipo de personal asociado al número de documento consultado.",
            //   tiempo: null,
            // });
            
            //////////////// Lógica para crear el Usuario //////////////////////////
            this.UsersData.numdoc_persona = this.documento_validar;
          
            ///////////////////////////////////////////////////////////////////////
            this.parametroComp = {
              evento: "agregar",
              item: { numdoc_persona: this.documento_validar},
              
            };
            this.compName = "formRegistroPersonal";
            this.estadoComponente = true;
          }
          this.id_tipo_personal = 0
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          // console.log(error);
        }
      }
    },

    //------------borrar nivel -------------
    async showmodalDelete(id) {
      this.confirm.id = id;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.active = true;
      this.confirm.action = 1;
    },
    /** 
     ________________________________________________________________________
    |          MÉTODO ACTUALIZAR ESTADO DEL PERSONA DINAMICAMENTE          */
    async updateStatePersonal(idpersona, estado) {

      let validaInt = estado ? 1 : 0;
      
      try {
        let resp = await axios.put(`/administrativo/personal/${idpersona}/${validaInt}`);

        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      } finally {
        this.getAll();
      }
    },
  },
};
</script>

<style>  /* ESTE ESTILO NO DEBE TENER SCOPED AUN ASI SE ESTABLECE 
 CLASES CUSTOM PARA APUNTAR UNICAMENTE A ESA CLASE SEGUIDO 
 DE LAS CLASES NATIVAS DEL COMPONENTE */
  .switch-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 40px;
  }

  .switch-text {
    position: absolute;
    pointer-events: none;
    font-weight: bold;
    font-size: 12px;
  }

  .switch-container .v-input--switch--inset .v-input--selection-controls__input,
  .switch-container .v-input--switch--inset .v-input--switch__track {
    width: 92px;
  }

  .v-application--is-ltr .switch-container .v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple,
  .v-application--is-ltr .switch-container .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
    transform: translate(65px) !important;
  }
</style>